/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbField } from "abreact/form/AbField";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbFilterTextInput } from "abreact/input/AbFilterTextInput";
import { AbRadioButtonGroup } from "abreact/input/AbRadioButtonGroup";
import { AbAutoSizer } from "abreact/layout/AbAutoSizer";
import { AbHBox } from "abreact/layout/AbHBox";
import { AbVBox } from "abreact/layout/AbVBox";
import { IconGrid } from "abreact/input/icon/IconGrid";
import { fetchIcons, matchIconToSearchTerm } from "abreact/input/icon/IconUtils";
import React, { useCallback, useMemo, useState } from 'react';

/**
 * For custom image styling in the Icon Search Picker
 */

/**
 * Can search ab icons and provide an onSelect
 */
export const AbIconPicker = ({
  onSelectImage,
  filterFunction,
  customStylings
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedImageId, setSelectedImageId] = useState(null);
  const defaultStyling = {
    displayName: AbReactResources.iconPicker_noStyle(),
    className: ""
  };
  const [selectedClassNameInfo, setSelectedClassNameInfo] = useState(defaultStyling);
  const classNameInfos = [defaultStyling, ...(customStylings ?? [])];
  const allImages = useMemo(() => fetchIcons(filterFunction), [filterFunction]);
  const displayedImages = useMemo(() => searchTerm ? allImages.filter(image => matchIconToSearchTerm(searchTerm, image)) : allImages, [allImages, searchTerm]);
  const onImageClick = useCallback(image => {
    onSelectImage?.(image);
    setSelectedImageId(image.fullId);
  }, [onSelectImage]);
  return /*#__PURE__*/React.createElement(AbVBox, {
    className: "ab-icon-picker",
    dataTestId: "ab-icon-picker",
    spacing: true
  }, /*#__PURE__*/React.createElement(AbHBox, {
    spacing: true
  }, /*#__PURE__*/React.createElement(AbFilterTextInput, {
    dataTestId: "icon-search-input",
    value: searchTerm,
    onChange: val => setSearchTerm(val)
  }), /*#__PURE__*/React.createElement("span", {
    className: "num-results"
  }, AbReactResources.imageSearch_searchResults(String(displayedImages.length), String(allImages.length)))), customStylings && /*#__PURE__*/React.createElement(AbField, {
    label: AbReactResources.iconPicker_style(),
    className: "icon-custom-styles",
    dataTestId: "icon-custom-styles",
    standalone: true
  }, /*#__PURE__*/React.createElement(AbRadioButtonGroup, {
    columns: classNameInfos.length,
    items: classNameInfos,
    value: selectedClassNameInfo,
    onChange: val => setSelectedClassNameInfo(val),
    keyFunction: item => item.className || "None",
    itemRenderer: item => item.displayName
  })), /*#__PURE__*/React.createElement("div", {
    className: "icon-grid-container"
  }, /*#__PURE__*/React.createElement(AbAutoSizer, {
    renderer: (width, height) => {
      return /*#__PURE__*/React.createElement(IconGrid, {
        images: displayedImages,
        className: selectedClassNameInfo?.className,
        onImageClick: onImageClick,
        selectedImageId: selectedImageId ?? undefined,
        width: width,
        height: height
      });
    }
  })));
};
//# sourceMappingURL=AbIconPicker.js.map
